<template>
    <!--Client Waiting List Page-->
    <div class="client-step3">
        <!--Step Three-->
        <div class="client-step3-wrap section-wrap">
            <!--Subtitle-->
            <h5>{{ $ml.get("waitingList.title") }} - {{ currentWaitingListStylist.first_name }}, {{
                currentWaitingListStylist.last_name }}</h5>
            <div class="steps">
                <p class="highlight-text">{{ $ml.get("waitingListClient.stepOne") }}</p>
                <i class="fa fa-check-circle-o" aria-hidden="true"></i>
            </div>
            <div class="steps">
                <p class="highlight-text">{{ $ml.get("waitingListClient.stepTwo") }}</p>
                <i class="fa fa-check-circle-o" aria-hidden="true"></i>
            </div>
            <div class="steps">
                <p class="highlight-text">{{ $ml.get("waitingListClient.stepThree") }}</p>
            </div>
            <p>
                {{ $ml.get("waitingListClient.stepTreeParagraph") }}
            </p>
            <div class="client-step3-wrap" v-if="!loading">
                <div class="select-service-date-wrap">
                    <div class="services-wrap">
                        <div>FROM</div>
                        <div class="service-inner-wrap">
                            <datepicker v-model="selectedDate.from" @selected="onFromDateChange" :format="dateFormat"
                                placeholder="MM/DD/YYYY" :disabled-dates="disabledDates">
                            </datepicker>
                            <div @click="resetCurrentDate(selectedDate.from)" class="close-date">
                                <i class="fa fa-times close-icon" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                    <div class="services-wrap">
                        <div>TO</div>
                        <div class="service-inner-wrap">
                            <datepicker v-model="selectedDate.to" :format="dateFormat" placeholder="MM/DD/YYYY"
                                :disabled-dates="disabledDatesDatepicker2" :open-date="startDatepicker2Date">
                            </datepicker>
                            <div @click="resetCurrentDate(selectedDate.to)" class="close-date">
                                <i class="fa fa-times close-icon" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <p>
                    {{ $ml.get("waitingListClient.stepTreeParagraph2") }}
                </p>
                <p class="text-error" v-if="selectedDate.from === '' || selectedDate.to === ''">{{
                    $ml.get("waitingList.note") }} {{ $ml.get("waitingListNotifications.dateRangeMessage") }}</p>
                <div class="next-btn">
                    <button type="button" class="primary-btn extra-small mobile"
                        @click="handleSaveClientWaitlistSettings"
                        :disabled="selectedDate.from === '' || selectedDate.to === ''"
                        :class="selectedDate.from === '' || selectedDate.to === '' ? 'disabled-button' : ''">
                        {{ $ml.get("general.saveContinue") }}
                    </button>
                    <button type="button" class="secondary-btn small mobile" @click="changeSection('client-step2')">
                        {{ $ml.get("general.goBack") }}
                    </button>
                </div>
                <span class="main-text-link" @click="handleSaveForLater">{{ $ml.get("general.saveLater") }}</span>
            </div>
            <main-loader v-if="loading"></main-loader>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import store from "../../../../../services/vuex";
import Datepicker from "vuejs-datepicker";
import api from "../../../../../services/api_endpoints";
import messages from "../../../../../services/messages";
import MainLoader from "../../../general-components/main_loader.vue";
import { max } from "moment/moment";


export default {
    data() {
        return {
            selectedDate: {
                from: '',
                to: '',
            },
            dateFormat: 'MM/dd/yyyy',
            disabledDates: {
                to: new Date(new Date().setHours(0, 0, 0, 0)), // Set time to 00:00:00 for today
            },
            disabledDatesDatepicker2: {
                to: new Date(),
                from: '',
            },
            loading: false,
            startDatepicker2Date: new Date(),
        };
    },
    computed: {
        currentWaitingListStylist: {
            get: function () {
                return store.state.currentWaitingListStylist;
            },
            set: function (value) {
                store.commit("setCurrentWaitingListStylist", value);
            },
        },
    },
    mounted() {
        if (this.currentWaitingListStylist.id) {
            this.getClientWaitlistSettings(this.currentWaitingListStylist.id);
        }
    },
    components: {
        Datepicker,
        MainLoader,
    },
    methods: {
        changeSection(section) {
            this.$emit('change-section', section);
        },
        resetCurrentDate(date) {
            if (this.selectedDate.from === date) {
                this.selectedDate.from = '';
                this.selectedDate.to = ''
            }

            if (this.selectedDate.to === date) {
                this.selectedDate.to = '';
            }
        },
        handleSaveClientWaitlistSettings() {
            this.saveClientWaitlistSettings();
            this.changeSection('client-step4');
        },
        saveClientWaitlistSettings() {
            if ((this.selectedDate.from === '' || this.selectedDate.from === '0000-00-00') &&
                (this.selectedDate.to === '' || this.selectedDate.to === '0000-00-00')) {
                return;
            }

            if (this.selectedDate.from === '' || this.selectedDate.from === '0000-00-00') {
                return
            }

            if (this.selectedDate.to === '' || this.selectedDate.to === '0000-00-00') {
                return
            }

            let data = {
                stylist_id: this.currentWaitingListStylist.id,
                from_date: moment(this.selectedDate.from).format('YYYY-MM-DD'),
                to_date: moment(this.selectedDate.to).format('YYYY-MM-DD'),
            };

            this.$http.post(api.actions.save_client_waitlist_settings, data).then((response) => {

                if (response.data.error == true) {
                    return;
                }

                this.getClientWaitlistSettings(this.currentWaitingListStylist.id);

                messages.successMessage(messages.GLOBAL_MESSAGES.WAITING_LIST_DATE_RANGE);
            });
            return;
        },
        getClientWaitlistSettings(stylistId) {
            this.loading = true;

            this.$http.get(api.actions.get_client_waitlist_settings + "/" + stylistId).then(
                function (response) {
                    if (response.data.error == true) {
                        return;
                    }

                    if ((response.data.settings.from_date !== '0000-00-00' && response.data.settings.from_date !== '')
                        && (response.data.settings.to_date !== '0000-00-00' && response.data.settings.to_date !== '')) {

                        this.selectedDate.from = response.data.settings.from_date;
                        this.selectedDate.to = response.data.settings.to_date;
                    }

                    this.loading = false;

                }.bind(this)
            );
        },
        onFromDateChange(date) {
            this.disabledDatesDatepicker2.from = date;
            this.startDatepicker2Date = date;

            this.limitFutureDays(date, 30)
            this.compareDates();
        },
        compareDates() {
            if (this.selectedDate.from && this.selectedDate.to) {
                const start = new Date(this.selectedDate.from);
                const end = new Date(this.selectedDate.to);

                // Compare the two dates
                if (end.getTime() > start.getTime()) {
                    this.selectedDate.to = ""; // Returns true if the end date is after the start date
                }
            }
        },
        limitFutureDays(startDate, days) {
            const date = new Date(startDate);

            date.setDate(date.getDate() + days);

            this.disabledDatesDatepicker2.from = date;
            this.disabledDatesDatepicker2.to = startDate;

            return date;
        },
        handleSaveForLater() {
            if (this.selectedDate.from === '' || this.selectedDate.to === '') {
                return
            }

            this.saveClientWaitlistSettings();
            this.changeSection('client-wlist');
        },
    },
};
</script>
